import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    error: [],
    loading: false,
    data: false
};

const slice = createSlice({
    name: "courseProgress",
    initialState,
    reducers: {
        CourseProgressRequest: (courseProgress) => {
            courseProgress.loading = true;
            courseProgress.error = false;
        },
        CourseProgressClear: (courseProgress) => {
            courseProgress.error = false;
            courseProgress.loading = false;
        },
        CourseProgressSuccess: (courseProgress, action) => {
            courseProgress.loading = false;
            courseProgress.error = false;
            courseProgress.data = action.payload;
        },
        CourseProgressError: (courseProgress, action) => {
            courseProgress.loading = false;
            courseProgress.error = action.payload;
        }
    }
});

export const { CourseProgressClear, CourseProgressRequest, CourseProgressSuccess, CourseProgressError } = slice.actions;

export default slice.reducer;
